var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { ModalContentItemWrapper, CardBody, CardHeader, CardFooter, HeaderSeparator, CloseButton, SegmentedControlRow, CardHeaderInnerWrapper, CardBodyInnerWrapper, CardFooterInnerWrapper, LinkAndSeparatorWrapper, TitleWrapper, ButtonPrev, IconChevron, ButtonNext, MobileControlsWrapper, ButtonsWrapper, DotsNavigation, Dot, TitleRow, StyledButton, ScrollGradient } from './styles';
import { goToItem, goToNextItem, goToPreviousItem, paddingToString } from './utils';
import { ButtonAsLink } from '../ButtonAsLink';
import { Icon } from '../Icon';
import { SegmentedControl } from '../SegmentedControl';
import { Text } from '../Text';
export var ModalContentItem = function (_a) {
  var _b, _c;
  var modalContentList = _a.modalContentList,
    events = _a.events,
    _d = _a.size,
    cardSize = _d === void 0 ? 'medium' : _d,
    fullscreenBgColor = _a.fullscreenBgColor,
    visible = _a.visible,
    modalContentItem = _a.modalContentItem,
    activeItem = _a.activeItem,
    setActiveItem = _a.setActiveItem,
    modalWrapperElement = _a.modalWrapperElement;
  var header = modalContentItem.header,
    body = modalContentItem.body,
    footer = modalContentItem.footer,
    style = modalContentItem.style;
  var refModalContentItemWrapper = useRef(null);
  var refCardHeaderInnerWrapper = useRef(null);
  var refCardBodyInnerWrapper = useRef(null);
  var refCardFooterInnerWrapper = useRef(null);
  var _e = useState(0),
    cardHeaderInnerWrapperHeight = _e[0],
    setCardHeaderInnerWrapperHeight = _e[1];
  var _f = useState(0),
    cardFooterInnerWrapperHeight = _f[0],
    setCardFooterInnerWrapperHeight = _f[1];
  var _g = useState(false),
    itemBodyContentDoesOverflow = _g[0],
    setItemBodyContentDoesOverflow = _g[1];
  useEffect(function () {
    var _a;
    if (refModalContentItemWrapper.current && refCardBodyInnerWrapper.current) {
      var modalHeight = (_a = refModalContentItemWrapper.current.parentElement) === null || _a === void 0 ? void 0 : _a.clientHeight;
      refCardHeaderInnerWrapper.current ? setCardHeaderInnerWrapperHeight(refCardHeaderInnerWrapper.current.clientHeight) : setCardHeaderInnerWrapperHeight(0);
      var cardBodyInnerWrapperHeight = refCardBodyInnerWrapper.current.clientHeight;
      refCardFooterInnerWrapper.current ? setCardFooterInnerWrapperHeight(refCardFooterInnerWrapper.current.clientHeight) : setCardFooterInnerWrapperHeight(0);
      if (modalHeight && cardHeaderInnerWrapperHeight + cardBodyInnerWrapperHeight + cardFooterInnerWrapperHeight > modalHeight) {
        setItemBodyContentDoesOverflow(true);
      }
    }
  }, [activeItem]);
  var footerLayout = (_b = footer === null || footer === void 0 ? void 0 : footer.layout) !== null && _b !== void 0 ? _b : 'column';
  var bothButtonsExist = (footer === null || footer === void 0 ? void 0 : footer.secondaryButton) !== undefined && (footer === null || footer === void 0 ? void 0 : footer.primaryButton) !== undefined;
  var buttonsWrapperIsDisplayed = (footer === null || footer === void 0 ? void 0 : footer.secondaryButton) !== undefined || (footer === null || footer === void 0 ? void 0 : footer.primaryButton) !== undefined;
  var showTitleRow = header !== undefined && (header.backLinkText !== undefined && header.backLinkAction !== undefined || header.title !== undefined || header.closeAction !== undefined);
  var headerElementsDisplayOptions = {
    backLinkIsDisplayed: (header === null || header === void 0 ? void 0 : header.backLinkText) !== undefined && (header === null || header === void 0 ? void 0 : header.backLinkAction) !== undefined,
    titleIsDisplayed: (header === null || header === void 0 ? void 0 : header.title) !== undefined,
    titleAlignment: header === null || header === void 0 ? void 0 : header.titleAlignment,
    closeButtonIsDisplayed: !!(header === null || header === void 0 ? void 0 : header.closeAction)
  };
  var footerElementsDisplayOptions = {
    mobileControlsWrapperIsDisplayed: modalContentList.length > 1,
    buttonsWrapperIsDisplayed: buttonsWrapperIsDisplayed
  };
  var showCardFooterInnerWrapper = footer !== undefined || modalContentList.length > 1;
  var actionButton = function (button, role) {
    var text = button.text,
      _a = button.size,
      size = _a === void 0 ? 'small' : _a,
      rest = __rest(button, ["text", "size"]);
    return _jsx(StyledButton, __assign({
      fullWidth: bothButtonsExist,
      overrideMaxWidth: !bothButtonsExist
    }, rest, {
      size: size,
      role: role,
      children: text
    }));
  };
  return _jsxs(ModalContentItemWrapper, {
    visible: visible,
    ref: refModalContentItemWrapper,
    children: [header && _jsx(CardHeader, {
      "data-cy-label": "modal-item-header",
      children: _jsxs(CardHeaderInnerWrapper, {
        cardSize: cardSize,
        ref: refCardHeaderInnerWrapper,
        children: [showTitleRow && _jsxs(TitleRow, {
          headerElementsDisplayOptions: headerElementsDisplayOptions,
          children: [header.backLinkText && header.backLinkAction && _jsxs(LinkAndSeparatorWrapper, {
            children: [_jsx(ButtonAsLink, {
              icon: "back",
              onClick: header.backLinkAction,
              children: header.backLinkText
            }), header.title && _jsx(HeaderSeparator, {
              cardSize: cardSize
            })]
          }), header.title && _jsx(TitleWrapper, {
            cardSize: cardSize,
            headerElementsDisplayOptions: headerElementsDisplayOptions,
            children: _jsx(Text, {
              el: "span",
              styleName: "title7",
              children: header.title
            })
          }), header.closeAction && _jsx(CloseButton, {
            onClick: header.closeAction,
            children: _jsx(Icon, {
              size: 24,
              type: "icon-times"
            })
          })]
        }), header.segmentedControl && _jsx(SegmentedControlRow, {
          children: _jsx(SegmentedControl, {
            selected: header.segmentedControl.selected,
            onClick: header.segmentedControl.onClick,
            tabs: header.segmentedControl.tabs
          })
        })]
      })
    }), _jsx(CardBody, {
      cardSize: cardSize,
      "data-cy-label": "modal-item-body",
      children: _jsx(CardBodyInnerWrapper, {
        cardSize: cardSize,
        footerElementsDisplayOptions: footerElementsDisplayOptions,
        itemBodyContentDoesOverflow: itemBodyContentDoesOverflow,
        ref: refCardBodyInnerWrapper,
        customPadding: paddingToString((_c = style === null || style === void 0 ? void 0 : style.body) === null || _c === void 0 ? void 0 : _c.padding),
        children: body
      })
    }), _jsxs(CardFooter, {
      cardSize: cardSize,
      "data-cy-label": "modal-item-footer",
      children: [itemBodyContentDoesOverflow && _jsx(ScrollGradient, {
        cardSize: cardSize,
        fullscreenBgColor: fullscreenBgColor
      }), showCardFooterInnerWrapper && _jsxs(CardFooterInnerWrapper, {
        cardSize: cardSize,
        ref: refCardFooterInnerWrapper,
        layout: footerLayout,
        children: [modalContentList.length > 1 && _jsxs(MobileControlsWrapper, {
          children: [_jsx(ButtonPrev, {
            onClick: function () {
              return goToPreviousItem({
                activeItem: activeItem,
                setActiveItem: setActiveItem,
                onItemPrev: events === null || events === void 0 ? void 0 : events.onItemPrev,
                modalWrapperElement: modalWrapperElement
              });
            },
            isVisible: activeItem > 0,
            hideOnDesktop: true,
            children: _jsx(IconChevron, {
              size: 16,
              type: "icon-chevron-left-big"
            })
          }), _jsx(DotsNavigation, {
            layout: footerLayout,
            children: modalContentList.map(function (_, index) {
              return _jsx("li", {
                children: _jsx(Dot, {
                  isActive: index === activeItem,
                  onClick: function () {
                    return goToItem({
                      itemIndex: index,
                      setActiveItem: setActiveItem,
                      modalWrapperElement: modalWrapperElement
                    });
                  }
                })
              }, index);
            })
          }), _jsx(ButtonNext, {
            onClick: function () {
              return goToNextItem({
                activeItem: activeItem,
                setActiveItem: setActiveItem,
                onItemNext: events === null || events === void 0 ? void 0 : events.onItemNext,
                modalContentList: modalContentList,
                modalWrapperElement: modalWrapperElement
              });
            },
            isVisible: activeItem < modalContentList.length - 1,
            hideOnDesktop: true,
            children: _jsx(IconChevron, {
              size: 16,
              type: "icon-chevron-right-big"
            })
          })]
        }), buttonsWrapperIsDisplayed && _jsxs(ButtonsWrapper, {
          layout: footerLayout,
          children: [footer.secondaryButton && actionButton(footer.secondaryButton, 'secondary'), footer.primaryButton && actionButton(footer.primaryButton, 'primary')]
        })]
      })]
    })]
  });
};